import { gsap } from '../global/gsap';

const initHoverLinks = (sections) => {
    let mm = gsap.matchMedia();

    mm.add('(min-width: 900px)', () => {
        sections.forEach((section) => {
            const links = section.querySelectorAll('.js-item');
            const mediaContainer = section.querySelector('.js-media-container');
            const mediaItems = section.querySelectorAll('.js-media-item');

            if (!mediaContainer) return;

            // gsap.set(mediaItems, {
            //     opacity: 0
            // });

            const moveMedia = (e) => {
                const link = e.currentTarget;
                const linkCenter = link.offsetTop + link.offsetHeight / 2;
                const targetY = linkCenter - mediaContainer.offsetHeight / 2;

                gsap.to(mediaContainer, {
                    y: targetY,
                    duration: 0.7,
                    ease: 'expo.out',
                    overwrite: 'auto',
                });
            };

            links.forEach((link) => {
                const linkIndex = link.dataset.index;
                link.addEventListener('mouseenter', (e) => {
                    moveMedia(e);
                    mediaItems.forEach((item, index) => {
                        item.classList.toggle('is-active', Number(linkIndex) === index);
                    });
                });
            });
        });
    });
};

export default initHoverLinks;
